import type { PermissionState } from './_state.type';

/** Permission State. */
export const permissionState: PermissionState = {
  permission: {
    account: true,
    processingHistory: true,
    services: true,
    users: true,
    groups: true,
    databases: true,
    databaseManagement: true,
    integrations: true,
    scanningProfiles: true,
    separationProfiles: true,
    globalVariables: true,
    aiModelLibrary: true,
    batchTypeLibrary: true,
    workQueueFilters: true,

    hitlActivities: true,

    analytics: true,
  },

  license: {
    packageLevel: 'none',
    aiProvider: [],
    analyticOptions: [],
    azureAiOptions: [],
    natifAiOptions: [],
    iPaaSOptions: undefined,
    singleSignOn: undefined,
    databaseOptions: [],
    isEnabledWss: false,
  },
};
